import type { IconSvgObject } from './types';

const CodeCircleIcon: IconSvgObject = [
  ["path", { d: "M14.5 9.5L17 12L14.5 14.5M9.5 9.5L7 12L9.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CodeCircleIcon;
